'use strict';

module.exports.flattenSimpleBlocks = require('./flatten-simple-blocks');
module.exports.fold = require('./fold');
module.exports.mergeStripes = require('./merge-stripes');
module.exports.removeEmptyBlocks = require('./remove-empty-blocks');
module.exports.removeZeroWidthStripes = require('./remove-zero-width-stripes');
module.exports.optimize = require('./optimize');



//////////////////
// WEBPACK FOOTER
// ./~/tartan-processing/src/transform/index.js
// module id = 106
// module chunks = 0